import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, MessageCircle, Instagram, Facebook } from 'lucide-react';

// Logo image URL from user
const LOGO_URL = "https://customer-assets.emergentagent.com/job_guest-experience-30/artifacts/yfd9yj4z_pixlr-image-generator-699c527fa82fb7194b38636b%20%281%29.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#0A0A0A] border-t border-[#2A2A2A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
              <img 
                src={LOGO_URL} 
                alt="Unlock Bags" 
                className="h-14 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-400 text-sm mb-6">
              Deposito bagagli automatizzato nel cuore di Napoli. Sicuro, veloce, senza code.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/unlockbags"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#2A2A2A] text-gray-400 hover:border-[#FFCC00] hover:text-[#FFCC00] transition-all duration-200"
                data-testid="footer-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com/unlockbags"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#2A2A2A] text-gray-400 hover:border-[#FFCC00] hover:text-[#FFCC00] transition-all duration-200"
                data-testid="footer-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6">
              Link Rapidi
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#come-funziona"
                  onClick={(e) => scrollToSection(e, '#come-funziona')}
                  className="text-gray-400 hover:text-[#FFCC00] text-sm transition-colors"
                >
                  Come Funziona
                </a>
              </li>
              <li>
                <a
                  href="#prezzi"
                  onClick={(e) => scrollToSection(e, '#prezzi')}
                  className="text-gray-400 hover:text-[#FFCC00] text-sm transition-colors"
                >
                  Prezzi
                </a>
              </li>
              <li>
                <a
                  href="#dimensioni"
                  onClick={(e) => scrollToSection(e, '#dimensioni')}
                  className="text-gray-400 hover:text-[#FFCC00] text-sm transition-colors"
                >
                  Dimensioni
                </a>
              </li>
              <li>
                <a
                  href="#sicurezza"
                  onClick={(e) => scrollToSection(e, '#sicurezza')}
                  className="text-gray-400 hover:text-[#FFCC00] text-sm transition-colors"
                >
                  Sicurezza
                </a>
              </li>
              <li>
                <a
                  href="#posizione"
                  onClick={(e) => scrollToSection(e, '#posizione')}
                  className="text-gray-400 hover:text-[#FFCC00] text-sm transition-colors"
                >
                  Posizione
                </a>
              </li>
              <li>
                <a
                  href="#contatti"
                  onClick={(e) => scrollToSection(e, '#contatti')}
                  className="text-gray-400 hover:text-[#FFCC00] text-sm transition-colors"
                >
                  Contatti
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6">
              Contatti
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="https://wa.me/393773781602"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-400 hover:text-[#FFCC00] text-sm transition-colors"
                >
                  <MessageCircle className="w-4 h-4 text-[#FFCC00]" />
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="tel:+393773781602"
                  className="flex items-center gap-3 text-gray-400 hover:text-[#FFCC00] text-sm transition-colors"
                >
                  <Phone className="w-4 h-4 text-[#FFCC00]" />
                  +39 377 378 1602
                </a>
              </li>
              <li>
                <a
                  href="mailto:unlockbags@gmail.com"
                  className="flex items-center gap-3 text-gray-400 hover:text-[#FFCC00] text-sm transition-colors"
                >
                  <Mail className="w-4 h-4 text-[#FFCC00]" />
                  unlockbags@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Location */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6">
              Posizione
            </h4>
            <div className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#FFCC00] flex-shrink-0 mt-1" />
              <div>
                <p className="text-gray-400 text-sm">
                  Via Ernesto Capocci 6<br />
                  80133 Napoli, Italia
                </p>
                <p className="text-gray-500 text-sm mt-2">
                  Aperto: 6:00 - 23:00
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#2A2A2A] mt-12 pt-8">
          {/* Payment & Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-6 mb-8">
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <svg className="w-8 h-5" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="38" height="24" rx="4" fill="#1A1F71"/>
                <path d="M15.5 15.5H13.5L14.8 8.5H16.8L15.5 15.5Z" fill="white"/>
                <path d="M22.5 8.7C22.1 8.5 21.4 8.4 20.6 8.4C18.6 8.4 17.2 9.4 17.2 10.9C17.2 12 18.2 12.6 18.9 13C19.7 13.4 19.9 13.7 19.9 14C19.9 14.5 19.3 14.7 18.7 14.7C17.9 14.7 17.4 14.6 16.7 14.3L16.4 14.1L16.1 15.9C16.6 16.1 17.5 16.3 18.4 16.3C20.5 16.3 21.9 15.3 21.9 13.7C21.9 12.8 21.3 12.1 20.2 11.5C19.5 11.1 19.1 10.9 19.1 10.5C19.1 10.2 19.5 9.9 20.2 9.9C20.9 9.9 21.4 10 21.7 10.2L21.9 10.3L22.5 8.7Z" fill="white"/>
                <path d="M25.5 8.5H24C23.5 8.5 23.2 8.7 23 9L20.1 15.5H22.2L22.6 14.3H25.2L25.5 15.5H27.3L25.5 8.5ZM23.2 12.8L24.1 10.3L24.6 12.8H23.2Z" fill="white"/>
                <path d="M12.4 8.5L10.5 13.3L10.3 12.3C9.9 11.1 8.8 9.8 7.5 9.1L9.3 15.5H11.4L14.5 8.5H12.4Z" fill="white"/>
                <path d="M9 8.5H5.7L5.6 8.7C8.1 9.3 9.8 10.9 10.3 12.3L9.7 9C9.6 8.7 9.3 8.5 9 8.5Z" fill="#F9A51A"/>
              </svg>
              <svg className="w-8 h-5" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="38" height="24" rx="4" fill="#252525"/>
                <circle cx="15" cy="12" r="7" fill="#EB001B"/>
                <circle cx="23" cy="12" r="7" fill="#F79E1B"/>
                <path d="M19 7.5C20.5 8.7 21.5 10.2 21.5 12C21.5 13.8 20.5 15.3 19 16.5C17.5 15.3 16.5 13.8 16.5 12C16.5 10.2 17.5 8.7 19 7.5Z" fill="#FF5F00"/>
              </svg>
              <span>Pagamento Sicuro</span>
            </div>
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
              </svg>
              <span>SSL Certificato</span>
            </div>
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <svg className="w-5 h-5 text-[#FFCC00]" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              <span>4.9/5 Recensioni</span>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Unlock Bags. Tutti i diritti riservati.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-500 hover:text-gray-400 text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-400 text-sm transition-colors">
                Termini di Servizio
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
